var _style, _polygon, _path, _polygon2, _path2, _path3, _path4, _polygon3, _polygon4, _path5, _polygon5, _path6, _path7, _polygon6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMayorOfLondonLogo1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.2 45.5",
    style: {
      enableBackground: "new 0 0 595.2 45.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4F4E50;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#4F4E50;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "44.1,0.9 34.2,0.9 22,17.4 9.6,0.9 0,0.9 0,44.6 10.2,44.6 10.2,17.4 22,32.8 34.2,17.4 34.2,44.6  44.1,44.6 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.4,36l3,8.6h11.2L75,0.9H64.6L48.5,44.5h11.1l2.8-8.6L77.4,36L77.4,36z M74.3,27.1h-8.9l4.5-14.3L74.3,27.1z "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "125.2,0.9 113.4,0.9 105,17.2 96.6,0.9 84.8,0.9 99.9,26.7 99.9,44.6 110.3,44.6 110.3,26.7 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.4,22.8C170.4,10,160.1,0,147,0c-13.1,0-23.2,9.8-23.2,22.6c0,12.9,10.2,22.9,23.4,22.9 C160.3,45.5,170.4,35.6,170.4,22.8 M160.2,22.7c0,7.6-5.8,13.6-13,13.6c-7.3,0-13.3-6.1-13.3-13.7c0-7.5,5.8-13.3,13.2-13.3 C154.6,9.2,160.2,15,160.2,22.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199,25.8c4.9-2.8,7.2-6.6,7.2-11.6c0-4.1-1.8-7.8-4.9-10.1c-3.6-2.6-6.2-3.2-13.4-3.2h-10.8v43.7h10.2V28h2 l11,16.5h11.5L199,25.8z M187.3,9h2c2.8,0,3.6,0.1,4.8,0.9c1.4,0.9,2.2,2.4,2.2,4.1c0,3.6-2.4,5.2-7.6,5.2h-1.4V9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.3,22.8C274.3,10,264.1,0,250.9,0c-13.1,0-23.2,9.8-23.2,22.6c0,12.9,10.2,22.9,23.4,22.9 C264.3,45.5,274.3,35.6,274.3,22.8 M264.2,22.7c0,7.6-5.8,13.6-13,13.6c-7.3,0-13.3-6.1-13.3-13.7c0-7.5,5.8-13.3,13.2-13.3 C258.5,9.2,264.2,15,264.2,22.7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "308.6,0.9 281.1,0.9 281.1,44.6 291.4,44.6 291.4,25.8 305.1,25.8 305.1,17 291.4,17 291.4,9.6  308.6,9.6 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "339.8,0.9 329.5,0.9 329.5,44.6 356.6,44.6 356.6,35.3 339.8,35.3 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404,22.8C404,10,393.7,0,380.6,0c-13.1,0-23.2,9.8-23.2,22.6c0,12.9,10.2,22.9,23.4,22.9 C393.9,45.5,404,35.6,404,22.8 M393.8,22.7c0,7.6-5.8,13.6-13,13.6c-7.3,0-13.3-6.1-13.3-13.7c0-7.5,5.8-13.3,13.2-13.3 C388.2,9.2,393.8,15,393.8,22.7"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "450.4,0.9 440.1,0.9 440.1,27.6 419.6,0.9 410.3,0.9 410.3,44.6 420.6,44.6 420.6,18.1 441.1,44.6  450.4,44.6 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458.9,0.9v43.7c3,0.1,6,0.1,8.9,0.1c7.9,0,10.5-0.1,13.6-0.9c3.5-0.7,6.8-2.6,9.6-5.2c4.1-4,6.5-9.8,6.5-16 c0-7.1-3.1-13.4-8.4-17.4c-4.5-3.3-8.5-4.3-17-4.3H458.9z M469.2,9.4c1-0.1,1.6-0.1,2.1-0.1c6.1,0,9.4,1,12.3,3.5 c2.6,2.3,3.9,5.6,3.9,9.8c0,6.7-3.6,11.5-9.5,12.8c-1.8,0.4-2.7,0.5-5.9,0.5h-2.9L469.2,9.4L469.2,9.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M548.8,22.8C548.8,10,538.6,0,525.4,0c-13.1,0-23.2,9.8-23.2,22.6c0,12.9,10.2,22.9,23.4,22.9 C538.8,45.5,548.8,35.6,548.8,22.8 M538.6,22.7c0,7.6-5.8,13.6-13,13.6c-7.3,0-13.3-6.1-13.3-13.7c0-7.5,5.8-13.3,13.2-13.3 C533,9.2,538.6,15,538.6,22.7"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "595.2,0.9 585,0.9 585,27.6 564.4,0.9 555.2,0.9 555.2,44.6 565.4,44.6 565.4,18.1 585.9,44.6  595.2,44.6 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMayorOfLondonLogo1);
export default __webpack_public_path__ + "static/media/Mayor_of_London_logo1.9c5c3ef6d17df89e1a2ae226316a4f13.svg";
export { ForwardRef as ReactComponent };